import { axios } from 'common/utils'
import { Template, TemplatesPage } from 'common/types/entities/mongo/template'
import { WindowsBanner } from 'common/types/entities/api/template'
import { isPcEnv } from 'common/utils/common'
import { TemplateManagerKey } from 'common/constants/templateManager'

export const fetchTemplate = async (id: string): Promise<Template> => {
  const response = await axios.get<Template>(`/v1/templates/${id}`)
  return response && response.data
}

export const fetchTemplateInstances = async (id: string, params: {}): Promise<Template[]> => {
  const response = await axios.get<Template[]>(`/v1/templates/${id}/instances`, { params })
  return response && response.data
}

export const fetchTemplateInstancesPage = async (id: string, params: {}): Promise<TemplatesPage> => {
  const response = await axios.get<TemplatesPage>(`/v1/templates/${id}/instances`, { params })
  return response && response.data
}

export const fetchTemplateInstance = async (templateId: string, instanceId: string): Promise<Template> => {
  const response = await axios.get<Template>(`/v1/templates/${templateId}/instances/${instanceId}`)
  return response && response.data
}

export const fetchWindowBanners = async (templateManagerKey: TemplateManagerKey) => {
  const response = await axios.get<WindowsBanner[]>(
    `/v1/templates/${templateManagerKey}/types/${isPcEnv ? 'PC' : 'MOBILE'}/banners`,
  )
  return response && response.data
}
